import toastr from 'toastr'
import i18n from '@src/plugins/i18n'

type Args = { icon: string; title: string; copyText?: string }

/**
 * Adiciona um botão "Copiar" dentro do toast, permitindo copiar o conteúdo
 * bruto do erro para diagnóstico posterior.
 */
const attachCopyButton = function (toastElement: any, copyText: string) {
    const element: HTMLElement | undefined = toastElement?.[0]
    if (!element) {
        return
    }

    const label = i18n.global.t('Core.btn.copy').toString()

    const wrapper = document.createElement('div')
    wrapper.style.cssText = [
        'display:flex',
        'justify-content:flex-end',
        'margin-top:6px',
    ].join(';')

    const button = document.createElement('button')
    button.type = 'button'
    button.title = label
    button.setAttribute('aria-label', label)
    button.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>'
    button.style.cssText = [
        'display:inline-flex',
        'align-items:center',
        'justify-content:center',
        'width:32px',
        'height:32px',
        'padding:0',
        'color:inherit',
        'background:rgba(0,0,0,.2)',
        'border:1px solid rgba(255,255,255,.4)',
        'border-radius:4px',
        'cursor:pointer',
        'transition:transform .15s ease, background .15s ease',
    ].join(';')

    button.addEventListener('click', (event) => {
        // Evita que o clique feche o toast (tapToDismiss do toastr)
        event.stopPropagation()
        event.preventDefault()
        navigator.clipboard.writeText(copyText).then(() => {
            /** Feedback visual rápido no próprio botão */
            button.style.transform = 'scale(1.25)'
            button.style.background = 'rgba(255,255,255,.35)'
            window.setTimeout(() => {
                button.style.transform = 'scale(1)'
                button.style.background = 'rgba(0,0,0,.2)'
            }, 150)
        })
    })

    wrapper.appendChild(button)
    element.appendChild(wrapper)
}

export const success = function (text: string) {
    toast({
        icon: 'success',
        title: text,
    })
}

export const info = function (text: string) {
    toast({
        icon: 'info',
        title: text,
    })
}

export const warning = function (text: string) {
    toast({
        icon: 'warning',
        title: text,
    })
}

export const debug = function (text: string) {
    const dev = import.meta.env.DEV
    if (dev)
        toast({
            icon: 'info',
            title: text,
        })
}

export const error = function (text: string) {
    toast({
        icon: 'error',
        title: text,
    })
}
const toast = function ({ icon, title, copyText }: Args) {
    toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        showDuration: 300,
        hideDuration: 1000,
        timeOut: 4000,
        extendedTimeOut: 3000,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',

        // fix: https://security.snyk.io/vuln/SNYK-JS-TOASTR-2396430
        escapeHtml: true,
    }
    let toastElement: any
    switch (icon.toLowerCase()) {
        case 'error':
            toastr.options.timeOut = 6000
            toastr.options.extendedTimeOut = 2000
            toastElement = toastr.error(title)
            break
        case 'warning':
            toastr.options.timeOut = 4000
            toastr.options.extendedTimeOut = 1000
            toastElement = toastr.warning(title)
            break
        case 'success':
            toastr.options.timeOut = 3000
            toastr.options.extendedTimeOut = 500
            toastElement = toastr.success(title)
            break
        case 'info':
        default:
            toastr.options.timeOut = 8000
            toastr.options.extendedTimeOut = 2000
            toastElement = toastr.info(title)
            break
    }

    if (copyText) {
        attachCopyButton(toastElement, copyText)
    }
}
export default toast
